module.exports = __webpack_public_path__ + "media/images/off_white_1_4_circle_left-b557943eb7f9db840ac983a330ddd15d.png";